import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@mui/styles';
import { useSnackbar } from 'notistack';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { CheckCircle as CheckCircleIcon, Cancel as ErrorIcon, Warning } from '@mui/icons-material';
import { Button } from 'bso-ui';

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 400,
    maxWidth: 500,
    padding: theme.spacing(1)
  },
  icon: {
    fontSize: 40,
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(1)
  },
  variantSuccess: {
    color: theme.palette.success.main
  },
  variantError: {
    color: theme.palette.error.main
  },
  variantInfo: {
    color: theme.palette.info.main
  },
  variantWarning: {
    color: theme.palette.warning.main
  }
}));

const capitalise = (text) => text.charAt(0).toUpperCase() + text.slice(1);

const SnackMessage = React.forwardRef((props, ref) => {
  const classes = useStyles();
  const { closeSnackbar } = useSnackbar();
  const {
    id, message, variant, 'data-testid': testid, onRetry
  } = props;

  const handleDismiss = () => {
    closeSnackbar(id);
  };

  const getIcon = () => {
    if (variant === 'success') {
      return <CheckCircleIcon className={classNames(classes.icon, classes[`variant${capitalise(variant)}`])} />;
    }
    if (variant === 'error') {
      return <ErrorIcon className={classNames(classes.icon, classes[`variant${capitalise(variant)}`])} />;
    } if (variant === 'warning') {
      return <Warning className={classNames(classes.icon, classes[`variant${capitalise(variant)}`])} />;
    }
    return <div />;
  };

  return (
    <Paper className={classes.paper} ref={ref}>
      {getIcon()}
      <Typography variant="body1" data-testid={testid}>{message}</Typography>
      <span style={{ flex: 1 }} />
      {onRetry && (
        <Button
          color="primary"
          size="small"
          onClick={onRetry}
        >
          Retry
        </Button>
      )}
      <IconButton onClick={handleDismiss}>
        <CloseIcon />
      </IconButton>
    </Paper>
  );
});

export default SnackMessage;
